<mat-sidenav-container>
  <mat-sidenav #sidenav="matSidenav" class="sidenav">
    <app-sidebar (onCloseSidenav)="sidenav.close()" [steps]="steps"></app-sidebar>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="sidebar">
      <button
        class="float-button"
        type="button"
        mat-button
        (click)="!home && sidenav.toggle()">
        <span class="vertical-text">Procedimiento</span>
      </button>
    </div>
    <div class="main-content">
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
